import { parseWasmResult } from '#wasm/common';
export class CompressorWasm {
    mod;
    DEFAULT_ACCELERATION = 1;
    constructor(mod) {
        this.mod = mod;
    }
    compress(raw) {
        return parseWasmResult(this.mod.Compress(raw));
    }
    decompress(compressed, maxDecompressedSize) {
        return parseWasmResult(this.mod.Decompress(compressed, maxDecompressedSize));
    }
    getName() {
        // Export the name getter from C++ if different accelerations are needed
        return `lz4 (acceleration ${this.DEFAULT_ACCELERATION})`;
    }
}
